module.exports = __webpack_public_path__ + "img/SES_211410001.78ec63fa.jpg";